// extracted by mini-css-extract-plugin
export default {"btnsBox":"ModalAction_btnsBox__IRhCs","confirmBtn":"ModalAction_confirmBtn__vpWeZ"};